const api = {
  baseUrl: process.env.NODE_ENV === 'development' ? 'http://101.132.189.225' : '',
  bannerList: {
    url: '/api.banner/list', // 轮播图列表
    method: 'get'
  },
  historyTextList: {
    url: '/api.history/textList', // 发展史文本
    method: 'get'
  },
  historyimageList: {
    url: '/api.history/imageList', // 发展史文本
    method: 'get'
  },
  appNoteHome: {
    url: '/api.note/home', // 首页提交
    method: 'post'
  },
  designerHomeList: {
    url: '/api.designer/homeList', // 设计师首页列表
    method: 'get'
  },
  designerList: {
    url: '/api.designer/list', // 设计师列表
    method: 'get'
  },
  designerdDetail: {
    url: '/api.designer/detail', // 设计师详情
    method: 'get'
  },
  articleList: {
    url: '/api.article/list', // 咨询列表
    method: 'get'
  },
  articleCategory: {
    url: '/api.article/category', // 咨询分类列表
    method: 'get'
  },
  articleDetail: {
    url: '/api.article/detail', // 咨询详情
    method: 'get'
  },
  ownerVoice: {
    url: '/api.ownerVoice/list', // 业主心声列表
    method: 'get'
  },
  ownerVoiceDetail: {
    url: '/api.ownerVoice/detail', // 业主心声列表
    method: 'get'
  },
  casesCategory: {
    url: '/api.cases/category', // 案例分类
    method: 'get'
  },
  casesList: {
    url: '/api.cases/list', // 案例列表
    method: 'get'
  },
  casesDetail: {
    url: '/api.cases/detail', // 案例详情
    method: 'get'
  },
  casesNote: {
    url: '/api.note/case', // 案例预约
    method: 'post'
  },
  housekeeperList: {
    url: '/api.housekeeper/list', // 管家列表
    method: 'get'
  },
  housekeeperNote: {
    url: '/api.note/housekeeper', // 管家预约
    method: 'post'
  },
  housekeeperDetail: {
    url: '/api.housekeeper/detail', // 管家详情--废弃
    method: 'post'
  },
  contactUs: {
    url: '/api.app/contactUs', // 联系我们
    method: 'get'
  },
  joinUs: {
    url: '/api.app/joinUs', //加入我们
    method: 'get'
  }
}
export default api
